import React, { useRef, useState } from "react";
import { Popover, PopoverBody } from "reactstrap";
import { AvailableFareSegmentModel } from "WebApiClient";

interface Props {
    segments: AvailableFareSegmentModel[];
}

export const RenderWaitlist: React.FC<Props> = ({ segments }) => {
    const elemRefs = useRef<(HTMLSpanElement | null)[]>([]);
    const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
    const handleMouseEnter = (index: number) => setOpenPopoverIndex(index);
    const handleMouseLeave = () => setOpenPopoverIndex(null);

    return (
        <>
            {segments.map((segment, index) => (
                <div key={`segment-${index}`}>
                    <div className="d-flex align-items-center pb-1">
                        <div className="w-25">{segment.bookingClass}</div>
                        <div>
                            {segment.freeSeats === 0 && (
                                <>
                                    <span
                                        className="WL cursor-pointer"
                                        ref={(el) => (elemRefs.current[index] = el)}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        WL
                                    </span>
                                    {elemRefs.current[index] && (
                                        <Popover
                                            target={elemRefs.current[index]!}
                                            isOpen={openPopoverIndex === index}
                                            className="operatedByCss"
                                            toggle={() => setOpenPopoverIndex(null)}
                                        >
                                            <PopoverBody>This flight is under Waitlist</PopoverBody>
                                        </Popover>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};
